export default {
  install(Vue) {
    // 有白边框
    Vue.prototype.getIdentityIcon = function (level) {
      if (typeof level === 'number' && !isNaN(level)) {
        if (level === 1 || level === 2) {
          return require('@/assets/img/icon_blue_v.png');
        } if (level === 3) {
          return require('@/assets/img/icon_blue_p.png');
        } if (level === 4) {
          return require('@/assets/img/icon_yello_v.png');
        } if (level === 5) {
          return require('@/assets/img/icon_yello_p.png');
        }
      }
      return '';
    };

    // 传过来的capInset单位为 像素，不需要除2
    Vue.prototype.getCapInsets = function (capInset) {
      if (Vue.Native && Vue.Native.Platform !== 'android') {
        return {
          top: capInset.top / 2,
          bottom: capInset.bottom / 2,
          left: capInset.left / 2,
          right: capInset.right / 2,
        };
      }

      return {
        top: capInset.top,
        bottom: capInset.bottom,
        left: capInset.left,
        right: capInset.right,
        height: capInset.height,
        width: capInset.width,
      };
    };
  },
};
